var map = {
	"./architecture_portfolio_app.png": 618519,
	"./auscycling_time_trial_app.png": 885242,
	"./bitcoin_dashboard.png": 83936,
	"./chess.png": 197975,
	"./dissecting_the_needle_drop.gif": 407829,
	"./glotex.png": 645584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 606247;